module.exports = __webpack_public_path__ + "static/media/tel-webconfirm.92763448.svg";